import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section, StatusBadge } from "@/components/Shared";
import { toast } from "sonner";

const STATUSES = ["all", "pending", "admin_approved", "approved", "rejected"];
const statusLabel = (s) => (s === "admin_approved" ? "admin approved" : s);

export default function AdminLeave() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    const q = status === "all" ? "" : `?status=${status}`;
    api.get(`/leave${q}`).then((r) => setList(r.data)).catch((e) => toast.error(formatErr(e)));
  }, [status]);

  return (
    <div data-testid="admin-leave">
      <PageHeader overline="Records" title="Leave History"
        subtitle="All leave requests in your scope. Approve or reject them in Pending Approvals."
        actions={<select value={status} onChange={(e) => setStatus(e.target.value)} className="h-10 border border-[#E5E5E5] px-3 bg-white" data-testid="leave-status-filter">
          {STATUSES.map((s) => <option key={s} value={s}>{statusLabel(s)}</option>)}</select>} />
      <Section title={`${list.length} ${status === "all" ? "requests" : statusLabel(status)}`}>
        <div className="overflow-x-auto">
          <table className="w-full table-dense min-w-[720px]">
            <thead>
              <tr className="border-b-2 border-[#1F4E8C] text-left">
                <th className="eyebrow">Employee</th><th className="eyebrow">Type</th>
                <th className="eyebrow">From</th><th className="eyebrow">To</th>
                <th className="eyebrow">Days</th><th className="eyebrow">Reason</th>
                <th className="eyebrow">Status</th><th className="eyebrow"></th>
              </tr>
            </thead>
            <tbody>
              {list.map((l) => (
                <tr key={l.id} className="border-b border-[#F0F0EE]" data-testid={`leave-row-${l.id}`}>
                  <td className="font-medium">{l.user_name}</td>
                  <td>{l.leave_type}</td>
                  <td>{l.from_date}</td><td>{l.to_date}</td>
                  <td>{l.days}</td>
                  <td className="max-w-[280px] truncate">{l.reason}</td>
                  <td><StatusBadge status={l.status} /></td>
                  <td>
                    {(l.status === "pending" || l.status === "admin_approved") && (
                      <Link to="/admin/approvals" className="text-xs font-semibold text-[#1F4E8C] underline underline-offset-2" data-testid={`leave-goto-approvals-${l.id}`}>
                        Review in Pending Approvals
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan={8} className="text-center py-8 text-neutral-500">No {statusLabel(status)} leave requests</td></tr>}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
}
